<template>
  <div id="pageRomaneios">
    <v-container grid-list-xs fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>
      <div v-if="!paginatationDisabled">
        <v-card>
          <v-card-text>
            <v-form @submit.prevent="searchRomaneio(1)">
              <v-layout row wrap grid-list-lg>
                <v-flex md2 xs12>
                  <v-dialog
                    ref="dialog"
                    v-model="formatDates.ini.modalDateInit"
                    persistent
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Período de"
                        prepend-icon="event"
                        :value="computedDateFormatted(searchData.date_ini)"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      @input="formatDates.ini.modalDateInit = false"
                      v-model="searchData.date_ini"
                      scrollable
                      locale="pt-br"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          formatDates.ini.modalDateInit = false;
                          searchData.date_ini = null;
                        "
                        >Limpar</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="formatDates.ini.modalDateInit = false"
                        >Cancelar</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex md2 xs12>
                  <v-dialog
                    ref="dialog"
                    v-model="formatDates.end.modalDateInit"
                    persistent
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Período de"
                        prepend-icon="event"
                        :value="computedDateFormatted(searchData.date_end)"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      @input="formatDates.end.modalDateInit = false"
                      v-model="searchData.date_end"
                      scrollable
                      locale="pt-br"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          formatDates.end.modalDateInit = false;
                          searchData.date_end = null;
                        "
                        >Limpar</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="formatDates.end.modalDateInit = false"
                        >Cancelar</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex md3 xs12>
                  <v-text-field
                    v-model="searchData.id"
                    label="N. Romaneio"
                  ></v-text-field>
                </v-flex>
                <v-flex md3 xs12>
                  <v-text-field
                    v-model="searchData.property_name"
                    label="Fazenda"
                  ></v-text-field>
                </v-flex>
                <v-flex md2 xs12>
                  <v-text-field
                    v-model="searchData.explorer_document"
                    label="Produtor (CPF/CNPJ)"
                  ></v-text-field>
                </v-flex>
                <v-flex md2 xs12>
                  <v-text-field
                    v-model="searchData.explorer_name"
                    label="Explorado nome"
                  ></v-text-field>
                </v-flex>

                <v-flex md2 xs12>
                  <v-text-field
                    label="SIF"
                    v-model="searchData.sif"
                  ></v-text-field>
                </v-flex>

                <v-flex md2 xs12>
                  <v-select
                    :items="itemsApproved"
                    item-text="text"
                    item-value="value"
                    v-model="searchData.is_approved"
                    label="Aprovado"
                  ></v-select>
                </v-flex>
                <v-flex md2 xs12>
                  <v-btn
                    @click="searchRomaneio(1)"
                    small
                    class="ma-1"
                    color="primary"
                  >
                    <v-icon class="body-1">fa-search</v-icon>Buscar
                  </v-btn>
                  <v-btn
                    :to="{ name: 'RomaneioIndex' }"
                    small
                    class="ma-1"
                    color="gray"
                    >Limpar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
        <br />
        <v-card
          v-if="!paginatationDisabled"
          class="card-romaneio hidden-sm-and-down grey darken-3"
        >
          <v-card-text>
            <v-layout row wrap class="white--text">
              <v-flex md3 xs12>Nr. Romaneio/Fazenda</v-flex>
              <v-flex md1 xs6 class="text-center">Município Fazenda</v-flex>
              <v-flex md1 xs4 class="text-center">Data do Abate</v-flex>
              <v-flex md1 xs4 class="text-center">Sexo / Categoria</v-flex>
              <v-flex md1 xs4 class="text-center">Qtde</v-flex>
              <v-flex md1 xs4 class="text-center">Média/PV</v-flex>
              <v-flex md1 xs4 class="text-center">Média/@</v-flex>
              <v-flex md1 xs4 class="text-center">Média/PC</v-flex>
              <v-flex md1 xs4 class="text-center">Média/RC</v-flex>
              <v-flex md1 xs4 class="text-center">Ações</v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card
          class="card-romaneio"
          v-for="(romaneio, idx) in romaneios.data"
          :key="`romaneio${romaneio.track_id}`"
        >
          <v-card-text>
            <v-layout row wrap>
              <v-flex md3 xs12>
                <span class="overline hidden-sm-and-down">
                  {{ romaneio.track_id }}
                  <br />
                </span>
                <strong>{{ romaneio.fazenda.nome }}</strong>
                <span class="caption hidden-md-and-up">
                  <br />
                  {{ romaneio.produtor.nome_razaosocial }}
                </span>
              </v-flex>
              <v-flex xs6 class="hidden-md-and-up">
                <img
                  v-if="romaneio.industry"
                  style="height: 50px; max-width: 100%; width: auto;"
                  :src="romaneio.industry.logo"
                />
              </v-flex>
              <v-flex md1 xs6 class="text-center">
                {{ romaneio.fazenda.cidade }}
                <br />
                {{ romaneio.fazenda.estado }}
              </v-flex>
              <v-flex md1 xs4 class="text-center">
                <label class="romaneio-label hidden-md-and-up" xs12
                  >Data do abate</label
                >
                <strong>{{ romaneio.dt_abate | formatDate }}</strong>
              </v-flex>

              <v-flex md1 xs4 class="text-center hidden-sm-and-down">
                <strong>{{ romaneio.sexo }}</strong> /
                <strong>{{ getCategory(romaneio) }}</strong>
              </v-flex>

              <v-flex md1 xs4 class="text-center hidden-md-and-up">
                <label class="romaneio-label">Sexo</label>
                <strong>{{ romaneio.sexo }}</strong>
              </v-flex>

              <v-flex md1 xs4 class="text-center hidden-md-and-up">
                <label class="romaneio-label">Categoria</label>
                <strong>{{ getCategory(romaneio) }}</strong>
              </v-flex>

              <v-flex md1 xs4 class="text-center">
                <label class="romaneio-label hidden-md-and-up"
                  >Quantidade</label
                >
                <strong>{{ romaneio.qtde_cab }}</strong>
              </v-flex>
              <v-flex md1 xs4 class="text-center">
                <label class="romaneio-label hidden-md-and-up">Peso vivo</label>
                <strong>
                  {{ romaneio.media_peso_vivo }}
                  <span class="hidden-sm-and-down">kg</span>
                </strong>
              </v-flex>
              <v-flex md1 xs4 class="text-center">
                <label class="romaneio-label hidden-md-and-up">Peso @</label>
                <strong>
                  {{ romaneio.media_arroba }}
                  <span class="hidden-sm-and-down">@</span>
                </strong>
              </v-flex>

              <v-flex md1 xs4 class="text-center">
                <label class="romaneio-label hidden-md-and-up">Total @</label>
                <strong>
                  {{ romaneio.media_peso_carcaca }}
                  <span class="hidden-sm-and-down">kg</span>
                </strong>
              </v-flex>
              <v-flex md1 xs4 class="text-center hidden-md-and-up">
                <label class="romaneio-label">Total KG</label>
                <strong>{{ romaneio.total_peso_carcaca }}</strong>
              </v-flex>
              <v-flex md1 xs4 class="text-center hidden-md-and-up">
                <label class="romaneio-label">% Contusão</label>
                <strong>{{ romaneio.porcentagem_contusoes }}</strong>
              </v-flex>

              <v-flex md1 xs4 class="text-center hidden-sm-and-down">
                <strong>{{ romaneio.media_rc }}%</strong>
              </v-flex>

              <v-flex md1 xs12 class="text-center">
                <v-btn
                  small
                  :to="{ name: 'Romaneio', params: { id: romaneio.track_id } }"
                  fab
                  color="primary"
                >
                  <v-icon class="body-1">fa-chart-bar</v-icon> </v-btn
                >&nbsp;
                <v-btn
                  v-if="romaneio.is_approved === false"
                  fab
                  small
                  color="success"
                  @click.stop="clickApproveRomaneio(romaneio, idx)"
                >
                  <v-icon>check</v-icon>
                </v-btn>
                <v-btn
                  v-if="romaneio.is_approved === true"
                  fab
                  small
                  color="error"
                  @click.stop="clickApproveRomaneio(romaneio, idx)"
                >
                  <v-icon>icofont-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <app-pagination
          v-if="romaneios && romaneios.pagination"
          :pagination="romaneios.pagination"
          :disabled="paginatationDisabled"
          v-on:change-page="searchRomaneio"
        ></app-pagination>
      </div>

      <app-confirm-modal
        :message="deleteMessage"
        :dialog="dialog"
        :modalType="modalType"
        v-on:choose="approveRomaneioConfirm"
      ></app-confirm-modal>

      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import appApi from "../../plugins/api";
import AppPagination from "../../components/Pagination";
import ConfirmModal from "../../components/ConfirmModal";
import moment from "moment";

export default {
  components: {
    "app-pagination": AppPagination,
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      isLoadingProperty: false,
      isLoadingExplorer: false,
      getProperties: null,
      getExplorers: null,
      properties: [],
      explorers: [],
      romaneios: {},
      currentPage: 1,
      paginatationDisabled: true,
      dialog: false,
      snackbarCsv: false,
      approveRomaneio: null,
      updateIdx: null,
      deleteMessage: "",
      modalType: null,
      snackbar: {},
      searchData: {
        is_approved: false
      },
      auxs: null,
      formatDates: {
        intlDate: "YYYY-MM-DD",
        ini: {
          date: "",
          modalDateInit: false
        },
        end: {
          date: "",
          modalDateInit: false
        }
      },
      itemsApproved: [
        { value: null, text: "Todos" },
        { value: true, text: "Sim" },
        { value: false, text: "Não" }
      ]
    };
  },

  computed: {},

  mounted: function() {
    window.scrollTo(0, 0);

    if (this.$route.query.page) {
      this.searchData["page"] = this.$route.query.page;
    } else {
      this.searchData["page"] = 1;
    }

    if (this.$route.query.sif) {
      this.searchData["sif"] = this.$route.query.sif;
    }

    if (this.$route.query.id) {
      this.searchData["id"] = this.$route.query.id;
    }
    if (this.$route.query.explorer_document) {
      this.searchData[
        "explorer_document"
      ] = this.$route.query.explorer_document;
    }
    if (this.$route.query.explorer_name) {
      this.searchData["explorer_name"] = this.$route.query.explorer_name;
    }
    if (this.$route.query.property_name) {
      this.searchData["property_name"] = this.$route.query.property_name;
    }
    if (this.$route.query.date_ini) {
      this.searchData["date_ini"] = this.$route.query.date_ini;
    }
    if (this.$route.query.date_end) {
      this.searchData["date_end"] = this.$route.query.date_end;
    }
    if (this.$route.query.is_approved) {
      this.searchData["is_approved"] = this.$route.query.is_approved;
    } else {
      this.searchData["is_approved"] = false;
    }

    appApi.getRomaneioAuxs().then(result => {
      this.auxs = result.data;
      this.getRomaneio(this.searchData);
    });
  },

  methods: {
    searchRomaneio: function(page) {
      const data = { page: page ? page : 1 };

      if (this.searchData.sif) {
        data["sif"] = this.searchData.sif;
      }
      if (this.searchData.id) {
        data["id"] = this.searchData.id;
      }
      if (this.searchData.explorer_document) {
        data["explorer_document"] = this.searchData.explorer_document;
      }
      if (this.searchData.explorer_name) {
        data["explorer_name"] = this.searchData.explorer_name;
      }
      if (this.searchData.property_name) {
        data["property_name"] = this.searchData.property_name;
      }
      if (this.searchData.date_ini) {
        data["date_ini"] = this.searchData.date_ini;
      }
      if (this.searchData.date_end) {
        data["date_end"] = this.searchData.date_end;
      }
      if (this.searchData.is_approved || this.searchData.is_approved === null) {
        data["is_approved"] = this.searchData.is_approved;
      } else {
        data["is_approved"] = false;
      }
      this.$router.push({ name: "RomaneioIndex", query: data });
    },

    getRomaneio: function(data) {
      this.paginatationDisabled = true;
      this.romaneios.data = [];
      appApi
        .getRomaneios(data)
        .then(result => {
          console.log(result.data);

          this.romaneios = result.data;
          this.paginatationDisabled = false;
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    clickApproveRomaneio(romaneio, updateIdx) {
      let p = "<p>" + romaneio.track_id;
      p += "<br>" + romaneio.fazenda.nome + "</br>";

      this.dialog = true;
      this.approveRomaneio = romaneio;
      this.updateIdx = updateIdx;
      this.modalType = romaneio.is_approved === false ? "success" : "error";
      this.deleteMessage =
        "<br>Tem certeza que deseja " +
        (romaneio.is_approved === false ? "aprovar" : "desaprovar") +
        " romaneio? <strong>" +
        p +
        "</strong>";
    },

    approveRomaneioConfirm(confirm) {
      this.dialog = false;
      if (confirm) {
        appApi
          .putApproveRomaneio(this.approveRomaneio.track_id)
          .then(romaneio => {
            this.romaneios.data[this.updateIdx] = romaneio.data;
            this.snackbar = {
              show: true,
              color: "green",
              text: romaneio.data.is_approved
                ? "Aprovado com sucesso."
                : "Desaprovado com sucesso."
            };
          })
          .catch(() => {
            this.getRomaneio(this.currentPage);
            this.snackbar = {
              show: true,
              color: "error",
              text: "Não foi possível alterar."
            };
          });
      }
    },

    getCategory(romeneio) {
      let category = "";
      let categories = {};
      for (let i = 0; i < romeneio.animals.length; i++) {
        categories[romeneio.animals[i].categoria_id] = categories[
          romeneio.animals[i].categoria_id
        ]
          ? categories[romeneio.animals[i].categoria_id] + 1
          : 1;
      }

      let greaterId = null;
      for (let key in categories) {
        if (!greaterId) greaterId = { id: key, value: categories[key] };
        if (categories[key] > greaterId.value) {
          greaterId = { id: key, value: categories[key] };
        }
      }

      return greaterId && this.auxs.category[greaterId.id]
        ? this.auxs.category[greaterId.id]
        : "";
    },

    computedDateFormatted(date) {
      if (date && date.trim().length > 0 && moment(date).isValid()) {
        return moment(date).format("DD/MM/YYYY");
      }
      return "";
    }
  }
};
</script>
<style scoped lang="css">
#pageRomaneios {
  position: relative;
}
#pageRomaneios .btn-add {
  position: fixed;
  top: 90px;
  left: calc(100% - 60px);
}
#pageRomaneios .card-romaneio {
  margin-bottom: 10px;
}
#pageRomaneios .card-romaneio .v-card__text {
  padding: 10px;
}

#pageRomaneios .romaneio-label {
  display: block;
}
</style>
